// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A86UmdTc2EJ80u7hGqAW{justify-content:space-between;align-items:center;font-size:13px;line-height:123%;display:flex}.Cvcgwuhn2CgO00HgXSNA{flex:1;max-width:406px;padding-top:16px;padding-bottom:16px}@media (min-width:992px){.Cvcgwuhn2CgO00HgXSNA{max-width:549px}}.EbLI_ltcEQN7BP8t5bNk{color:var(--content-primary-primary);font-weight:500}._dMQgA_R1sMg6Ken5YHN:empty{display:none}._dMQgA_R1sMg6Ken5YHN{color:var(--content-primary-tertiary);margin-top:4px}.dVIHRfJV67ASjvU5AbK6{text-align:right;flex:none;justify-content:flex-end;width:54px;margin-left:auto;display:flex}.J2xZQeNKbYwqCQJm0sQZ{flex:none;margin-left:auto;padding-left:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `A86UmdTc2EJ80u7hGqAW`,
	"infoWrap": `Cvcgwuhn2CgO00HgXSNA`,
	"title": `EbLI_ltcEQN7BP8t5bNk`,
	"description": `_dMQgA_R1sMg6Ken5YHN`,
	"switcherWrap": `dVIHRfJV67ASjvU5AbK6`,
	"contentWrap": `J2xZQeNKbYwqCQJm0sQZ`
};
export default ___CSS_LOADER_EXPORT___;
